const normalizarRole = (nome) => String(nome ?? '').trim().toLowerCase()

const extrairNomeRole = (role) => {
  if (!role) return ''
  if (typeof role === 'string') return role
  return role.name ?? role.role_name ?? ''
}

function usuarioPossuiRole(usuario, rolesPermitidas = []) {
  if (!usuario?.id) return false

  const permitidas = rolesPermitidas.map(normalizarRole)
  const roles = Array.isArray(usuario.roles) ? usuario.roles : []

  if (roles.some(role => permitidas.includes(normalizarRole(extrairNomeRole(role))))) {
    return true
  }

  return permitidas.includes(normalizarRole(extrairNomeRole(usuario.role_ativo)))
}

function usuarioEhAdmin(usuario) {
  return usuarioPossuiRole(usuario, ['administrador'])
}

export {
  usuarioPossuiRole,
  usuarioEhAdmin,
}
